export default "__VITE_ASSET__iVIf$ZRu__"